module.exports = __webpack_public_path__ + "static/media/carlisle_demo.e9406b6e.png";